export const SchemeObjectTypes = {
  typeSamples: 'type_samples',
  typeSampleSources: 'type_sample_sources',
};

export const SchemeNodeTypes = {
  sample: 'sample',
  storage: 'storage',
  qualityControl: 'quality_control',
};

export const SchemeResourceTypes = {
  device_models: 'device_models',
};

export const SchemeNodeOperationTypes = {
  addObject: 1,
  removeNode: 2,
  removeQualityControl: 3,
  addNode: 4,
};

export const SchemeModes = {
  view: 1,
  edit: 2,
};

export const StatusIteration = {
  NotStarted: 'not_started',
  InProgress: 'in_progress',
  Completed: 'completed',
  ForceCompleted: 'force_completed',
};

export const STATUS_CONFIG = {
  [StatusIteration.NotStarted]: {
    text: 'Не начат',
    color: '#FF0000',
  },
  [StatusIteration.InProgress]: {
    text: 'В процессе',
    color: '#EE6F00',
  },
  [StatusIteration.Completed]: {
    text: 'Завершён',
    color: '#01B454',
  },
  [StatusIteration.ForceCompleted]: {
    text: 'Остановлен',
    color: '#FF0000',
  },
};
